wbApp.factory('ageRangeSvc', ['$resource', 'repositorySvc',
    function ($resource, repositorySvc) {

        var AgeRange = $resource('/Api/AgeRanges/:id', {}, {
            'getAll': { method: 'GET', isArray: true, url: '/Api/AgeRanges/GetAll' },
            'update': { method: 'POST', url: '/Api/AgeRanges/Update' },
            'insert': { method: 'POST', url: '/Api/AgeRanges/Insert' },
            'delete': { method: 'POST', url: '/Api/AgeRanges/Delete' }
        });

        var ageRanges;

        function getAllAsync(refresh) {

            if (!ageRanges || refresh) {
                ageRanges = repositorySvc.customGet('getAll', AgeRange);
            }

            return ageRanges;
        }


        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                AgeRange,                  // $resource
                ageRanges,                 // collection
                data,                      // entity
                successCallback,
                errorCallback,
                'ageRangeID');
        }


        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                AgeRange,                         // $resource
                ageRanges,                        // collection
                data,                             // entity
                successCallback,
                errorCallback,
                'ageRangeID');
        }

        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                AgeRange,                            // $resource
                ageRanges,                            // collection
                { ageRangeID: data.ageRangeID },           // entity
                successCallback,
                errorCallback,
                {
                    ageRangeID: data.ageRangeID
                },
                'ageRangeID');
        }

        function createNew() {
            return {
                ageRangeID: 0,
                fromAge: 0,
                toAge: 199,
                buildIn: false
            };
        }

        return {
            getAllAsync: getAllAsync,
            insert: insert,
            update: update,
            remove: remove,
            createNew: createNew
        }

    }]);